export default {
  company_name: 'AIX JAPAN株式会社',
  locale: 'ja_JP',
  nav_philosophy: 'フィロソフィー',
  nav_service: '事業内容',
  nav_cases: '導入事例',
  nav_company: '会社概要',
  nav_member: 'メンバー',
  nav_recruit: '採用情報',
  nav_news: 'お知らせ',
  nav_contact: 'お問い合わせ',
  nav_menu_toggle: 'メニュー',
  flow_activities_label: '具体的な作業',
  flow_duration_label: '期間目安',
  flow_deliverables_label: '成果物',
  flow_client_asks_label: 'お客様にお願いすること',
  nf_meta_title: '404 Not Found | AIX JAPAN',
  nf_title: 'お探しのページは見つかりませんでした',
  nf_desc: 'URLが変更されたか、ページが存在しない可能性があります。',
  nf_back: 'トップページへ戻る',
  cta_contact: 'お問い合わせ',
  cta_contact_sub: 'CONTACT',
  cta_recruit: '採用情報',
  cta_recruit_sub: 'RECRUIT',
  footer_services: 'SERVICES',
  footer_company: 'COMPANY',
  footer_more: 'MORE',
  footer_faq: 'よくあるご質問',
  footer_privacy: 'プライバシーポリシー',
  footer_security: '情報セキュリティ方針',
  footer_copyright: '© AIX JAPAN株式会社 All Rights Reserved.',
  footer_page_top: 'PAGE TOP',
  footer_description: 'AIとあらゆる領域を掛け合わせ、\n企業の変革と成長を実現する\nトータルコンサルティング。',
  footer_cta_text: 'AI領域に関する課題、AI戦略立案、AI人材不足など\nご質問等あれば\nお気軽にお問い合わせくださいませ。',
  service_sd: 'AIX コンサルティング',
  service_sdx: 'AIX マネージャー',
  service_se: 'AIX トレーニング',
  service_ai_tool: '生成AI All In One Tool',
  cta_band_title: '貴社の課題をお聞かせください',
  cta_band_text: '業種や規模を問わず、現場に定着するAI導入を伴走支援します。\nまずは課題の整理からお気軽にご相談ください。',
  cta_band_button: 'お問い合わせ',
  lang_ja: 'JA',
  lang_en: 'EN',
};